import { render, staticRenderFns } from "./authvaultedcard.vue?vue&type=template&id=2b7c964a&"
import script from "./authvaultedcard.vue?vue&type=script&lang=js&"
export * from "./authvaultedcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports